export default {
    props: {
        editable: {
            type: Boolean,
            default: false
        }
    }
}
